export default "__VITE_ASSET__L8ioN_LV__"